import { useState, useEffect } from 'react'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { callAxios } from '../hooks/useAxios'
import { Group } from '../types/models'

interface GroupEmailSettingsProps {
  group: Group
}

export function GroupEmailSettings({ group }: GroupEmailSettingsProps): React.ReactElement | null {
  const { t } = useTranslation()
  const [installer, setInstaller] = useState<boolean>(
    !!group.settings?.diagnostic_emails_installer
  )
  const [customer, setCustomer] = useState<boolean>(
    !!group.settings?.diagnostic_emails_customer
  )

  useEffect(() => {
    setInstaller(!!group.settings?.diagnostic_emails_installer)
    setCustomer(!!group.settings?.diagnostic_emails_customer)
  }, [group])

  if (!group.editable || !group.id) return null

  const update = async (key: string, value: boolean) => {
    await callAxios(
      { method: 'PATCH', url: `/user-groups/${group.id}` },
      { settings: { [key]: value } }
    )
  }

  const onInstallerChange = (v: boolean) => {
    setInstaller(v)
    update('diagnostic_emails_installer', v)
  }

  const onCustomerChange = (v: boolean) => {
    setCustomer(v)
    update('diagnostic_emails_customer', v)
  }

  return (
    <Box sx={{ my: 4 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        {t('Diag-group-emails-section')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {t('Diag-group-emails-explain')}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={installer}
              onChange={(e) => onInstallerChange(e.target.checked)}
            />
          }
          label={t('Diag-group-installer-emails')}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={customer}
              onChange={(e) => onCustomerChange(e.target.checked)}
            />
          }
          label={t('Diag-group-customer-emails')}
        />
      </Box>
    </Box>
  )
}
